// Green Peas
// DETAILS
// Product: Green Peas
// Form: Whole
// OPTIONS
// Size: 4-8mm | 8-10mm | Uncalibrated
// Packaging Sizes: 20x400gm | 10x1kg | 4x2.5kg | 10kg | 25kg | 35kg | Custom
// Brands: Neoteric | Palmera | Private Label
// Origin: Poland | Egypt
// SPECS
// Freezing Technique: IQF (Individually Quick Frozen)
// Size Tolerance: 10% off-size
// Ingredients: Green Peas (100%)
// Color: Vibrant green
// Blanching: Sufficient to inactivate the peroxidase enzyme system.
// Shelf Life: Up to 2 years
// Food Safety: HACCP, Non-GMO
// Packaging Material: LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags
// Storage: -18°C

// Cut Green Beans
// Product: Cut Green Beans
// Form: Cut
// Length: 10-20mm | 20-40mm | Uncalibrated
// Packaging Sizes: 20x400gm | 10x1kg | 4x2.5kg | 10kg | 25kg | 35kg | Custom
// Brands: Neoteric | Palmera | Private Label
// Origin: Poland | Egypt
// Freezing Technique: IQF (Individually Quick Frozen)
// Size Tolerance: 10% off-size
// Ingredients: Green Beans (100%)
// Color: Vibrant green
// Blanching: Sufficient to inactivate the peroxidase enzyme system.
// Shelf Life: Up to 2 years
// Food Safety: HACCP, Non-GMO
// Packaging Material: LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags
// Storage: -18°C

// const products = [
//   {
//     code: "green-peas",
//     name: "Green Peas",
//     description:
//       "Green peas are a popular vegetable. They are also quite nutritious and contain a fair amount of fiber and antioxidants. Additionally, research shows they may help protect against some chronic illnesses, such as heart disease and cancer.",
//     images: ["/img/products/green-peas.jpg"],
//     details: [
//       {
//         title: "Product",
//         description: "Green Peas",
//       },
//       {
//         title: "Form",
//         description: "Whole",
//       },
//     ],
//     options: [
//       {
//         title: "Size",
//         values: ["4-8mm", "8-10mm", "Uncalibrated"],
//       },
//       {
//         title: "Packaging Sizes",
//         values: [
//           "20x400gm",
//           "10x1kg",
//           "4x2.5kg",
//           "10kg",
//           "25kg",
//           "35kg",
//           "Custom",
//         ],
//       },
//       {
//         title: "Brands",
//         values: ["Neoteric", "Palmera", "Private Label"],
//       },
//       {
//         title: "Origin",
//         values: ["Poland", "Egypt"],
//       },
//     ],
//     specs: [
//       {
//         title: "Freezing Technique",
//         description: "IQF (Individually Quick Frozen)",
//       },
//       {
//         title: "Size Tolerance",
//         description: "10% off-size",
//       },
//       {
//         title: "Ingredients",
//         description: "Green Peas (100%)",
//       },
//       {
//         title: "Color",
//         description: "Vibrant green",
//       },
//       {
//         title: "Blanching",
//         description: "Sufficient to inactivate the peroxidase enzyme system.",
//       },
//       {
//         title: "Shelf Life",
//         description: "Up to 2 years",
//       },
//       {
//         title: "Food Safety",
//         description: "HACCP, Non-GMO",
//       },
//       {
//         title: "Packaging Material",
//         description:
//           "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags",
//       },
//       {
//         title: "Storage",
//         description: "-18°C",
//       },
//     ],
//   },
// ];

const Products = [
  {
    code: "peas",
    name: "Green Peas",
    description:
      "Green peas are a popular vegetable. They are also quite nutritious and contain a fair amount of fiber and antioxidants. Additionally, research shows they may help protect against some chronic illnesses, such as heart disease and cancer.",
    images: [
      "/img/products/closeup/peas.jpg",
      "/img/products/neoteric/peas-400a.png",
      "/img/products/neoteric/peas-400b.png",
      "/img/products/palmera/peas-400a.png",
      "/img/products/palmera/peas-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Green Peas",
      },
      {
        title: "Form",
        description: "Whole",
      },
    ],
    options: [
      {
        title: "Size",
        values: ["4-8mm", "8-10mm", "Uncalibrated"],
      },
      {
        title: "Packaging Sizes",
        values: [
          "20x400gm",
          "10x1kg",
          "4x2.5kg",
          "10kg",
          "25kg",
          "35kg",
          "Custom",
        ],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
      {
        title: "Origin",
        values: ["Poland", "Egypt"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Size Tolerance",
        description: "10% off-size",
      },
      {
        title: "Ingredients",
        description: "Green Peas (100%)",
      },
      {
        title: "Color",
        description: "Vibrant green",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate the peroxidase enzyme system.",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "cut-beans",
    name: "Cut Green Beans",
    description:
      "Cut green beans are a versatile vegetable that can be used in various dishes, from salads to stir-fries. They are a good source of vitamins and minerals, including vitamin C, vitamin K, and manganese.",
    images: [
      "/img/products/closeup/cut-beans.jpg",
      "/img/products/neoteric/cut-beans-400a.png",
      "/img/products/neoteric/cut-beans-400b.png",
      "/img/products/palmera/cut-beans-400a.png",
      "/img/products/palmera/cut-beans-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Cut Green Beans",
      },
      {
        title: "Form",
        description: "Cut",
      },
    ],
    options: [
      {
        title: "Length",
        values: ["10-20mm", "20-40mm", "Uncalibrated"],
      },
      {
        title: "Packaging Sizes",
        values: [
          "20x400gm",
          "10x1kg",
          "4x2.5kg",
          "10kg",
          "25kg",
          "35kg",
          "Custom",
        ],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
      {
        title: "Origin",
        values: ["Poland", "Egypt"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Size Tolerance",
        description: "10% off-size",
      },
      {
        title: "Ingredients",
        description: "Green Beans (100%)",
      },
      {
        title: "Color",
        description: "Vibrant green",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate the peroxidase enzyme system.",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "cauliflower",
    name: "Cauliflower",
    description:
      "Cauliflower is a versatile vegetable that can be used in a variety of dishes, from soups to stir-fries. It is low in calories but high in vitamins and minerals, making it a nutritious addition to any diet.",
    images: [
      "/img/products/closeup/cauliflower.jpg",
      "/img/products/neoteric/cauliflower-400a.png",
      "/img/products/neoteric/cauliflower-400b.png",
      "/img/products/palmera/cauliflower-400a.png",
      "/img/products/palmera/cauliflower-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Cauliflower",
      },
      {
        title: "Form",
        description: "Florets",
      },
    ],
    options: [
      {
        title: "Size",
        values: ["20-40mm", "40-60mm", "Uncalibrated"],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "10x1kg", "4x2.5kg", "12kg", "Custom"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
      {
        title: "Origin",
        values: ["Poland", "Egypt"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Size Tolerance",
        description: "20% off-size",
      },
      {
        title: "Ingredients",
        description: "Cauliflower Florets (100%)",
      },
      {
        title: "Color",
        description: "Creamy White",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate the peroxidase enzyme system.",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "broccoli",
    name: "Broccoli",
    description:
      "Broccoli is a nutritious vegetable that is rich in vitamins, minerals, and antioxidants. It is known for its high content of vitamin C and vitamin K, as well as its potential health benefits, including reduced risk of cancer and improved bone health.",
    images: [
      "/img/products/closeup/broccoli.jpg",
      "/img/products/neoteric/broccoli-400a.png",
      "/img/products/neoteric/broccoli-400b.png",
      "/img/products/palmera/broccoli-400a.png",
      "/img/products/palmera/broccoli-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Broccoli",
      },
      {
        title: "Form",
        description: "Florets",
      },
    ],
    options: [
      {
        title: "Size",
        values: ["20-40mm", "40-60mm", "Uncalibrated"],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "10x1kg", "4x2.5kg", "12kg", "Custom"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
      {
        title: "Origin",
        values: ["Poland", "Egypt"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Size Tolerance",
        description: "20% off-size",
      },
      {
        title: "Ingredients",
        description: "Broccoli Florets (100%)",
      },
      {
        title: "Color",
        description: "Deep Green",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate the peroxidase enzyme system.",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "spinach",
    name: "Spinach",
    description:
      "Spinach is a leafy green vegetable that is rich in vitamins, minerals, and antioxidants. It is low in calories but high in nutrients, making it a healthy addition to any diet.",
    images: [
      "/img/products/closeup/spinach.jpg",
      "/img/products/neoteric/spinach-400a.png",
      "/img/products/neoteric/spinach-400b.png",
      "/img/products/palmera/spinach-400a.png",
      "/img/products/palmera/spinach-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Chopped Spinach",
      },
      {
        title: "Form",
        description: "Chopped and formed into a block",
      },
    ],
    options: [
      {
        title: "Origin",
        values: ["Egypt"],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "4x2.5kg"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "Blast Frozen",
      },
      {
        title: "Ingredients",
        description: "Spinach (100%)",
      },
      {
        title: "Color",
        description: "Deep Green",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate the peroxidase enzyme system",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE bags in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "molokhia",
    name: "Molokhia",
    description:
      "Molokhia is a leafy green vegetable that is popular in Middle Eastern and North African cuisine. It is often used to make a soup or stew known as molokhia. It is rich in vitamins, minerals, and antioxidants.",
    images: [
      "/img/products/closeup/molokhia.jpg",
      "/img/products/neoteric/molokhia-400a.png",
      "/img/products/neoteric/molokhia-400b.png",
      "/img/products/palmera/molokhia-400a.png",
      "/img/products/palmera/molokhia-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Minced Molokhia",
      },
      {
        title: "Form",
        description: "Minced and formed into a block",
      },
    ],
    options: [
      {
        title: "Origin",
        values: ["Egypt"],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "4x2.5kg"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "Blast Frozen",
      },
      {
        title: "Ingredients",
        description: "Molokhia (100%)",
      },
      {
        title: "Color",
        description: "Deep Green",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate the peroxidase enzyme system",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE bags in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "artichoke",
    name: "Artichoke",
    description:
      "Artichoke bottoms are a versatile ingredient that can be used in a variety of dishes, from salads to pasta. They have a mild, slightly sweet flavor and a tender texture.",
    images: [
      "/img/products/closeup/artichokes.jpg",
      "/img/products/neoteric/artichokes-400a.png",
      "/img/products/neoteric/artichokes-400b.png",
      "/img/products/palmera/artichokes-400a.png",
      "/img/products/palmera/artichokes-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Artichoke Bottoms",
      },
      {
        title: "Form",
        description: "Bottoms",
      },
    ],
    options: [
      {
        title: "Size",
        values: ["30-50mm", "50-70mm", "70-90mm", "Uncalibrated"],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "10x1kg", "4x2.5kg", "10kg", "Custom"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Size Tolerance",
        description: "10% off-size",
      },
      {
        title: "Ingredients",
        description: "Artichoke Bottoms (100%)",
      },
      {
        title: "Color",
        description: "Creamy",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate the peroxidase enzyme system",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "okra",
    name: "Okra",
    description:
      "Okra is a vegetable that is popular in many cuisines around the world. It has a unique texture and flavor, and it is often used in dishes such as soups, stews, and stir-fries. Okra is also a good source of vitamins and minerals.",
    images: [
      "/img/products/closeup/okra.jpg",
      "/img/products/neoteric/okra-zero-400a.png",
      "/img/products/neoteric/okra-zero-400b.png",
      "/img/products/palmera/okra-extra-400a.png",
      "/img/products/palmera/okra-extra-400b.png",
      "/img/products/palmera/okra-zero-400a.png",
      "/img/products/palmera/okra-one-400a.png",
    ],
    details: [
      {
        title: "Product",
        description: "Okra",
      },
      {
        title: "Form",
        description: "Whole",
      },
    ],
    options: [
      {
        title: "Size",
        values: [
          "Extra (≤ 15mm)",
          "Zero (≤ 25mm)",
          "One (25-35mm)",
          "Two (35-45mm)",
          "Uncalibrated",
        ],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "4x2.5kg", "10kg", "Custom"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Size Tolerance",
        description: "10% off-size",
      },
      {
        title: "Ingredients",
        description: "Okra (100%)",
      },
      {
        title: "Color",
        description: "Green",
      },
      {
        title: "Blanching",
        description: "Sufficient to inactivate enzymes",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "diced-carrots",
    name: "Diced Carrots",
    description:
      "Diced carrots are a convenient way to add color, flavor, and nutrition to a variety of dishes. They can be used in soups, stews, salads, and stir-fries, and they are a good source of vitamins and minerals.",
    images: ["/img/products/closeup/carrot.jpg"],
    details: [
      {
        title: "Product",
        description: "Diced Carrots",
      },
      {
        title: "Form",
        description: "Diced",
      },
    ],
    options: [
      {
        title: "Origin",
        values: ["Poland", "Egypt"],
      },
      {
        title: "Packaging Sizes",
        values: ["10kg", "25kg", "40kg"],
      },
      {
        title: "Brands",
        values: ["Private Label"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "peas-carrot",
    name: "Peas and Carrots",
    description:
      "Peas and carrots is a classic combination of two popular vegetables often served together in various dishes. Both peas and carrots offer nutritional benefits and contribute to the vibrant colors and flavors of many meals.",
    images: [
      "/img/products/closeup/peas-carrot.jpg",
      "/img/products/neoteric/peas-carrot-400a.png",
      "/img/products/neoteric/peas-carrot-400b.png",
      "/img/products/palmera/peas-carrot-400a.png",
      "/img/products/palmera/peas-carrot-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Peas and Carrots",
      },
      {
        title: "Ingredients",
        description: "Green Peas, Diced Carrots",
      },
      {
        title: "Form",
        description: "Whole peas, diced carrots, mixed",
      },
      {
        title: "Size - Diced Carrots",
        description: "10x10x10mm cubes",
      },
      {
        title: "Size - Green Peas",
        description: "4-8mm, 8-10mm, Uncalibrated",
      },
    ],
    options: [
      {
        title: "Ratio (Peas : Carrots)",
        values: ["Equal", "60/40", "70/30", "Custom"],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "10x1kg", "4x2.5kg", "10kg", "25kg", "35kg"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
      {
        title: "Origin",
        values: ["Poland", "Egypt"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Color",
        description: "Multi-color (vibrant green for peas, orange for carrots)",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "mixed-3-way",
    name: "3-Way Mixed Vegetables",
    description:
      "A combination of diced carrots, cut green beans, and green peas, this mixed vegetable blend offers convenience and versatility in cooking. Whether used in soups, stir-fries, or casseroles, it adds color, flavor, and nutrition to your dishes.",
    images: [
      "/img/products/closeup/mixed-3-way.jpg",
      "/img/products/neoteric/mixed-3-way-400a.png",
      "/img/products/neoteric/mixed-3-way-400b.png",
      "/img/products/palmera/mixed-3-way-400a.png",
      "/img/products/palmera/mixed-3-way-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "3-Way Mixed Vegetables",
      },
      {
        title: "Ingredients",
        description: "Diced Carrots, Cut Green Beans, Green Peas",
      },
      {
        title: "Form",
        description: "Various, mixed",
      },
    ],
    options: [
      {
        title: "Size - Diced Carrots",
        values: ["10x10x10mm"],
      },
      {
        title: "Length - Cut Green Beans",
        values: ["10-20mm", "20-40mm", "Uncalibrated"],
      },
      {
        title: "Size - Green Peas",
        values: ["4-8mm", "8-10mm", "Uncalibrated"],
      },
      {
        title: "Ratio (Carrots : Beans : Peas)",
        values: ["Equal", "40/35/25", "50/35/15", "60/30/10", "Custom"],
      },
      {
        title: "Packaging Sizes",
        values: [
          "20x400gm",
          "10x1kg",
          "4x2.5kg",
          "10kg",
          "25kg",
          "35kg",
          "Custom",
        ],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Color",
        description: "Multi-color (orange, vibrant green)",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "mixed-4-way",
    name: "4-Way Mixed Vegetables",
    description:
      "A delightful blend of diced carrots, cut green beans, green peas, and sweet corn kernels, this mixed vegetable medley offers both flavor and nutrition to your favorite dishes. Whether used in soups, salads, or side dishes, it adds color and texture to any meal.",
    images: [
      "/img/products/closeup/mixed-4-way.jpg",
      "/img/products/neoteric/mixed-4-way-400a.png",
      "/img/products/neoteric/mixed-4-way-400b.png",
      "/img/products/palmera/mixed-4-way-400a.png",
      "/img/products/palmera/mixed-4-way-400b.png",
    ],
    details: [
      {
        title: "Product",
        description: "4-Way Mixed Vegetables",
      },
      {
        title: "Ingredients",
        description:
          "Diced Carrots, Cut Green Beans, Green Peas, Sweet Corn Kernels",
      },
      {
        title: "Form",
        description: "Various, mixed",
      },
    ],
    options: [
      {
        title: "Size - Diced Carrots",
        values: ["10x10x10mm"],
      },
      {
        title: "Length - Cut Green Beans",
        values: ["10-20mm", "20-40mm", "Uncalibrated"],
      },
      {
        title: "Size - Green Peas",
        values: ["4-8mm", "8-10mm", "Uncalibrated"],
      },
      {
        title: "Size - Sweet Corn Kernels",
        values: ["Uncalibrated"],
      },
      {
        title: "Ratio (Carrots : Beans : Peas : Corn)",
        values: [
          "30/20/20/30",
          "Equal",
          "30/30/20/20",
          "40/35/15/10",
          "Custom",
        ],
      },
      {
        title: "Packaging Sizes",
        values: [
          "20x400gm",
          "10x1kg",
          "4x2.5kg",
          "10kg",
          "25kg",
          "35kg",
          "Custom",
        ],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Color",
        description: "Multi-color (orange, vibrant green, yellow)",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box | PP bags",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "strawberry",
    name: "Strawberry",
    description:
      "Strawberries are a delicious and nutritious fruit known for their bright red color, juicy texture, and sweet flavor. Packed with vitamins, minerals, and antioxidants, they are a popular choice for snacks, desserts, and smoothies.",
    images: [
      "/img/products/closeup/strawberry.jpg",
      "/img/products/neoteric/strawberry-1000a.png",
      "/img/products/neoteric/strawberry-1000b.png",
      "/img/products/palmera/strawberry-1000a.png",
      "/img/products/palmera/strawberry-1000b.png",
    ],
    details: [
      {
        title: "Product",
        description: "Strawberry",
      },
      {
        title: "Form",
        description: "Whole",
      },
    ],
    options: [
      {
        title: "Size",
        values: ["15-20mm", "20-25mm", "25-35mm", "35-40mm", "Uncalibrated"],
      },
      {
        title: "Packaging Sizes",
        values: ["20x400gm", "10x1kg", "4x2.5kg", "1x10kg", "Custom"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Palmera", "Private Label"],
      },
      {
        title: "Origin",
        values: ["Poland", "Egypt"],
      },
    ],
    specs: [
      {
        title: "Freezing Technique",
        description: "IQF (Individually Quick Frozen)",
      },
      {
        title: "Size Tolerance",
        description: "10% off-size",
      },
      {
        title: "Ingredients",
        description: "Strawberries (100%)",
      },
      {
        title: "Color",
        description: "Vibrant red",
      },
      {
        title: "Shelf Life",
        description: "Up to 2 years",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description:
          "LDPE+PET laminated bags in a carton box | LDPE lining in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
  {
    code: "french-fries",
    name: "French Fries",
    description:
      "French fries are a popular and beloved side dish or snack made from potatoes. They are typically deep-fried or oven-baked until crispy and golden brown. Whether enjoyed on their own or paired with burgers, sandwiches, or other dishes, they are a versatile and tasty treat.",
    images: [
      "/img/products/closeup/fries.jpg",
      "/img/products/neoteric/french-fries-1000a.png",
      "/img/products/neoteric/french-fries-1000b.png",
      "/img/products/neoteric/french-fries-2500a.png",
      "/img/products/neoteric/french-fries-2500b.png",
    ],
    details: [
      {
        title: "Product",
        description: "French Fries",
      },
      {
        title: "Form",
        description: "Cut potatoes",
      },
      {
        title: "Cut",
        description: "6x6mm, 10x10mm",
      },
      {
        title: "Grade (length)",
        description: "A (75% > 50mm), B (50% > 50mm)",
      },
      {
        title: "Origin",
        description: "Egypt",
      },
      {
        title: "Processing Technique",
        description: "Blanched and Par-Fried",
      },
    ],
    options: [
      {
        title: "Packaging Sizes",
        values: ["10x1kg", "4x2.5kg"],
      },
      {
        title: "Brands",
        values: ["Neoteric", "Private Label"],
      },
    ],
    specs: [
      {
        title: "Color",
        description: "Light yellow",
      },
      {
        title: "Shelf Life",
        description: "Up to 24 months",
      },
      {
        title: "Food Safety",
        description: "HACCP, Non-GMO",
      },
      {
        title: "Packaging Material",
        description: "LDPE+PET laminated bags in a carton box",
      },
      {
        title: "Storage",
        description: "-18°C",
      },
    ],
  },
];

export default Products;
